export default "__VITE_ASSET__DN4c7P22__"